// extracted by mini-css-extract-plugin
export default {"loading":"loading-dots_loading__PpUP6","spacer":"loading-dots_spacer__8jpkM","blink":"loading-dots_blink__t8MkH"};